import React from 'react';

const TopBar = ({ 
  dateRange, 
  onDateRangeChange, 
  onExport, 
  overviewMode, 
  onOverviewToggle,
  dataSource,
  onDataSourceChange,
  selectedTrialType,
  availableTrialTypes,
  onTrialTypeChange
}) => {
  const handleExport = (type) => {
    if (type === 'pdf') {
      // Create a simple PDF-like report
      const reportData = {
        title: 'Journey Protector Shipment Report',
        dateRange: dateRange,
        timestamp: new Date().toLocaleString(),
        content: 'This is a mock PDF export. In a real implementation, this would generate a proper PDF document with shipment data, charts, and analytics.'
      };
      
      // Simulate PDF generation
      console.log('Generating PDF report:', reportData);
      console.log('PDF Export: This would generate a comprehensive shipment report with charts and analytics.');
      
    } else if (type === 'csv') {
      // Create CSV data
      const csvData = [
        ['Shipment ID', 'Origin', 'Destination', 'Status', 'Distance (km)', 'Duration (hrs)', 'Anomalies'],
        ['SHIP-001', 'York, UK', 'London, UK', 'completed', '320', '6', '2'],
        ['SHIP-002', 'London, UK', 'Cardiff, UK', 'completed', '230', '6', '1'],
        ['SHIP-003', 'Cardiff, UK', 'Manchester, UK', 'completed', '280', '6', '0'],
        ['SHIP-004', 'Manchester, UK', 'Leeds, UK', 'completed', '65', '3', '1'],
        ['SHIP-005', 'Leeds, UK', 'York, UK', 'pending', '35', '1.5', '0']
      ];
      
      // Convert to CSV string
      const csvContent = csvData.map(row => row.join(',')).join('\n');
      
      // Create and download file
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `journey-protector-shipments-${dateRange.start}-${dateRange.end}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      console.log('CSV exported successfully');
    }
  };

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4">
      {/* Top row - Logo and Export buttons */}
      <div className="flex items-center justify-between mb-4">
        {/* Logo */}
        <div className="flex items-center">
          <img 
            src="/JP Logo.png" 
            alt="JP Logo" 
            className="w-12 h-12 mr-3 object-contain"
          />
          <h1 className="text-xl font-semibold text-gray-900">Journey Protector</h1>
        </div>

        {/* Export Buttons and Overview Toggle */}
        <div className="flex items-center space-x-3">
          <button
            onClick={onOverviewToggle}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              overviewMode 
                ? 'bg-purple-600 text-white hover:bg-purple-700' 
                : 'bg-gray-600 text-white hover:bg-gray-700'
            }`}
          >
            {overviewMode ? 'Single View' : 'Overview'}
          </button>
          <button
            onClick={() => handleExport('pdf')}
            className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
          >
            Export PDF
          </button>
          <button
            onClick={() => handleExport('csv')}
            className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors"
          >
            Export CSV
          </button>
        </div>
      </div>

      {/* Bottom row - Data source, trial type, and date range */}
      <div className="flex items-center justify-between">
        {/* Data Source and Trial Type Selectors */}
        <div className="flex items-center space-x-4">
          {/* Data Source Selector */}
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">Data Source:</label>
            <select
              value={dataSource}
              onChange={(e) => onDataSourceChange(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="trial">Trial Data (SQLite)</option>
              <option value="mock">Mock Data</option>
            </select>
          </div>

          {/* Trial Type Selector (only show when using trial data) */}
          {dataSource === 'trial' && (
            <div className="flex items-center space-x-2">
              <label className="text-sm font-medium text-gray-700">Trial Type:</label>
              <select
                value={selectedTrialType}
                onChange={(e) => onTrialTypeChange(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {availableTrialTypes.map(trialType => (
                  <option key={trialType} value={trialType}>
                    {trialType}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Date Range Selector */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Date Range:</label>
          <input
            type="date"
            value={dateRange.start}
            onChange={(e) => onDateRangeChange({ ...dateRange, start: e.target.value })}
            className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-gray-500">to</span>
          <input
            type="date"
            value={dateRange.end}
            onChange={(e) => onDateRangeChange({ ...dateRange, end: e.target.value })}
            className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default TopBar; 